// Date utility functions for shoot management

/**
 * Check if a shoot date has passed (is in the past)
 * @param shootDate - The date string in YYYY-MM-DD format
 * @returns true if the date has passed, false otherwise
 */
export const isShootDatePassed = (shootDate: string): boolean => {
  const today = new Date()
  const shoot = new Date(shootDate + 'T00:00:00') // Add time to avoid timezone issues
  
  // Set today to start of day for fair comparison
  today.setHours(0, 0, 0, 0)
  
  return shoot < today
}

/**
 * Get the status that a shoot should have based on its date
 * @param shootDate - The date string in YYYY-MM-DD format
 * @param currentStatus - The current status of the shoot
 * @returns the status the shoot should have
 */
export const getExpectedShootStatus = (shootDate: string, currentStatus: string): string => {
  // Don't change status if it's already completed, cancelled, or in_progress
  if (['completed', 'cancelled', 'in_progress'].includes(currentStatus)) {
    return currentStatus
  }
  
  // If the shoot date has passed and it's still scheduled, it should be completed
  if (currentStatus === 'scheduled' && isShootDatePassed(shootDate)) {
    return 'completed'
  }
  
  return currentStatus
}

/**
 * Format a date for API queries (YYYY-MM-DD)
 * @param date - The date object to format
 * @returns formatted date string
 */
export const formatDateForApi = (date: Date): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Check if a shoot is upcoming (today or in the future)
 * @param shootDate - The date string in YYYY-MM-DD format
 * @returns true if the shoot is upcoming, false otherwise
 */
export const isShootUpcoming = (shootDate: string): boolean => {
  return !isShootDatePassed(shootDate)
} 